export default function removeSessionService() {
    return function (toState, fromState, stateStr, stateAdd, item) {
        // $scope.$on('$stateChangeStart',(e,toState,fromState)=>{
        if (toState.name.indexOf(stateStr) == -1 && fromState.name.indexOf(stateStr) != -1) sessionStorage.removeItem(item)
        stateAdd && fromState.name.indexOf(stateStr) != -1 && stateAdd.forEach((stateName) => {
            if (fromState.name === stateName) sessionStorage.removeItem(item)
        })
        // })
    }
}



// WEBPACK FOOTER //
// ./src/common/services/removeSessionService.js